import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const FacebookIcon = (props: IconProps) => (
  <ChakraIcon
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <path
      d="M1.95652 1C1.42825 1 1 1.42825 1 1.95652V22.0435C1 22.5718 1.42825 23 1.95652 23H13.4237V14.6314H10.5652V11.173H13.4237V8.53514C13.4237 5.53434 15.0838 3.86957 17.6378 3.86957C18.8608 3.86957 20.1304 4.12204 20.1304 4.12204V7.0492H18.7306C17.3431 7.0492 16.8986 7.98022 16.8986 8.92701L16.9011 11.173H20.0052L19.5091 14.6314H16.9011V23H22.0435C22.5718 23 23 22.5718 23 22.0435V1.95652C23 1.42825 22.5718 1 22.0435 1H1.95652Z"
      fill="currentColor"
    />
  </ChakraIcon>
);
